import { useEffect, useState } from 'react';

const INTERACTION_EVENTS = ['scroll', 'touchstart', 'mousemove'] as const;

interface UseLogoAnimationProps {
  isCardVisible: boolean;
}

export function useLogoAnimation(props: UseLogoAnimationProps): boolean {
  const { isCardVisible } = props;
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const onInteraction = () => setHasInteracted(true);
    INTERACTION_EVENTS.forEach((event) => window.addEventListener(event, onInteraction, { once: true, passive: true }));
    return () => INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, onInteraction));
  }, []);

  useEffect(() => {
    if (hasInteracted && isCardVisible) {
      setIsAnimated(true);
    }
  }, [hasInteracted, isCardVisible]);

  return isAnimated;
}
